export default __webpack_public_path__ + "static/media/blunderbomb_alone.9936ee94.png";